import React from 'react';
import BemClass from '@upsales/components/Utils/bemClass';
import { Text } from '@upsales/components';
import { useTranslation } from 'Components/Helpers/translate';
import type CustomField from 'App/resources/Model/CustomField';
import type FieldDependency from 'App/resources/Model/FieldDependency';
import { isVisibilityRule } from 'App/helpers/fieldDependencies';
import './FieldDependencyEditor.scss';

type Props = {
	fieldId: number | null;
	customFields: CustomField[];
	rules: FieldDependency[];
};

/** Tells which rule a field takes part in. Rules are set up on the Dynamic fields page, so nothing changes here. */
const FieldDependencyEditor = ({ fieldId, customFields, rules }: Props) => {
	const classes = new BemClass('FieldDependencyEditor');
	const { t } = useTranslation();

	const ruleOnField = rules.find(rule => rule.fieldId === fieldId);
	if (!ruleOnField) {
		return null;
	}
	const field = customFields.find(other => other.id === ruleOnField.parentFieldId)?.name;
	return (
		<div className={classes.b()}>
			<Text size="sm" color="grey-11">
				{isVisibilityRule(ruleOnField)
					? t('admin.fields.fieldDependency.shownWhen', { field })
					: t('admin.fields.fieldDependency.dependsOnField', { field })}
			</Text>
			<Text size="sm" color="grey-11">
				{t('admin.fields.fieldDependency.setOnPage')}
			</Text>
		</div>
	);
};

export default FieldDependencyEditor;
